<!--
    @author bluefirex
-->
<template>
    <a :class="['acquisit-signature-type-button', 'type-' + type.type]"
       @click="onClick"
       @keyup.enter="onEnter">
	    <span class="icon" aria-hidden="true" v-if="icon">
		    <v-svg :file="icon" multi-color />
	    </span>
	    
	    <span class="meta" role="presentation">
		    <acquisit-string class="title"
		                     role="presentation"
		                     :source="type.choice_button.title" />
		    
		    <acquisit-string class="subtitle"
		                     role="presentation"
		                     v-if="type.choice_button.subtitle"
		                     :source="type.choice_button.subtitle" />
	    </span>
	    
	    <span class="chevron" aria-hidden="true">
		    <v-svg file="chevrons/right" />
	    </span>
    </a>
</template>

<script setup lang="ts">
	import { useColor, useColorProps } from '@Visma-Real-Estate-Solutions/acquisit-ui-vue/helpers'
	import { computed, type PropType } from 'vue'
	import type { AnySignatureType } from '@/lib/types'
	
	const props = defineProps({
		...useColorProps(),
		
		type: {
			type: Object as PropType<AnySignatureType>,
			required: true
		}
	})
	
	const color = useColor(props)
	
	const icon = computed(() => {
		return {
			'bankid': 'acq/bankid',
			//'manual': 'acq/signature-manual'
		}[props.type.type] ?? undefined
	})
	
	const onClick = (e: MouseEvent) => {
		emit('click', e)
	}
	
	const onEnter = (e: KeyboardEvent) => {
		emit('click', e)
	}
	
	const emit = defineEmits<{
		click: [e: MouseEvent | KeyboardEvent]
	}>()
</script>

<style lang="scss">
    @use '@/assets/mixins.scss' as m;
    
    .acquisit-signature-type-button {
	    display: flex;
	    align-items: center;
	    gap: 16px;
	    cursor: pointer;
	    
	    padding: 16px 32px;
	    
	    transition: background 0.2s, color 0.2s, border 0.2s;
	    
	    > .icon {
		    width: 32px;
		    height: 24px;
	    }
	    
	    > .meta {
		    flex: 1;
		    transition: background 0.2s, color 0.2s;
		    
		    .title {
			    font-weight: 600;
			    font-size: 1rem;
		    }
		    
		    .subtitle {
			    color: v-bind("color.textSecondary.value.cssHSLA");
		    }
	    }
	    
	    > .chevron {
		    width: 24px;
		    height: 32px;
	    }
	    
	    @media (hover: hover) {
		    
		    &:hover {
			   background: v-bind("color.backgroundLightTinted.value.cssHSLA");
		    }
	    }
	    
	    &.type-manual {
		    padding: 0px 32px;
		    border: 0px !important;
		    
		    margin: {
			    top: 16px;
		    }
		    
		    > .meta {
			    border-radius: 8px;
			    padding: 8px 0px;
			    
			    .title {
				    text-align: center;
				    font-weight: normal;
			    }
		    }
		    
		    > .chevron {
			    display: none;
		    }
		    
		    &:hover {
			    background: none;
			    
			    > .meta {
				    background: v-bind("color.backgroundLightTinted.value.cssHSLA");
			    }
		    }
	    }
    }
</style>